import { render } from "./ListGroup.vue?vue&type=template&id=4faf8778&scoped=true"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"

import "./ListGroup.vue?vue&type=style&index=0&id=4faf8778&scoped=true&lang=css"
import "./ListGroup.vue?vue&type=style&index=1&id=4faf8778&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faf8778"]])

export default __exports__